import { useCallback } from 'react';

import { useIntersectionObserver } from './useIntersectionObserver';

import type { MutableRefObject, RefObject } from 'react';

const DEFAULT_INTERSECTION_THRESHOLD = 0.8;

export const useViewObserver = ({
  onView,
  threshold = DEFAULT_INTERSECTION_THRESHOLD,
  elementRef,
  enabled,
}: {
  onView: () => void;
  threshold?: IntersectionObserverInit['threshold'];
  elementRef: MutableRefObject<HTMLElement> | RefObject<HTMLElement>;
  enabled?: boolean;
}) => {
  const handleIntersectionChange = useCallback(
    (entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        onView();
      }
    },
    [onView]
  );

  useIntersectionObserver({
    onIntersectionChange: handleIntersectionChange,
    threshold,
    elementRef,
    enabled,
  });
};
